gl-attribute-values ion-note {
  font-size: 14px;
  line-height: 14px;
  padding-top: 16px;
  text-align: right;
}
